import { useState } from 'react';
import { motion } from 'framer-motion';
import BlacksmithWorkshop from '../components/BlacksmithWorkshop';
import Select from 'react-select';

const PAYMENT_OPTIONS = [
  { value: 'ICP', label: 'ICP' },
  { value: 'ckBTC', label: 'ckBTC' },
  { value: 'ckSOL', label: 'ckSOL' },
  { value: 'ckUSDC', label: 'ckUSDC' },
  { value: 'ckETH', label: 'ckETH' },
];

const PRICE_USD = 100;

export default function LegacyMembers() {
  const [selectedPayment, setSelectedPayment] = useState(PAYMENT_OPTIONS[0]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [minted, setMinted] = useState(false);

  const handleMint = async () => {
    setIsProcessing(true);
    
    try {
      // Process payment via RPC canister
      // Calculate equivalent amount based on selected token
      // Call payment canister
      
      // Simulate payment processing
      await new Promise(resolve => setTimeout(resolve, 3000));
      
      setMinted(true);
    } catch (err) {
      console.error('Payment failed:', err);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <BlacksmithWorkshop>
      <div className="container mx-auto px-4 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-2xl mx-auto"
        >
          <div className="glass-dark rounded-2xl p-8 text-center mb-8">
            <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-gold to-yellow-400 bg-clip-text text-transparent">
              Legacy Members
            </h1>
            <p className="text-xl text-gray-300 mb-2">Exclusive Collection of 888 NFTs</p>
            <p className="text-lg text-gray-400">Join the elite founders of The Forge</p>
          </div>

          {!minted ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="glass-dark rounded-2xl p-8"
            >
              <div className="mb-6">
                <label className="block text-gray-300 mb-2">Payment Method</label>
                <Select
                  value={selectedPayment}
                  onChange={(opt) => setSelectedPayment(opt || PAYMENT_OPTIONS[0])}
                  options={PAYMENT_OPTIONS}
                  className="text-black"
                />
              </div>

              <div className="mb-6 p-4 bg-black/30 rounded-lg">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-300">Price:</span>
                  <span className="text-2xl font-bold text-gold">${PRICE_USD}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-400">Token:</span>
                  <span className="text-lg text-white">{selectedPayment.label}</span>
                </div>
              </div>

              <button
                onClick={handleMint}
                disabled={isProcessing}
                className="w-full bg-gold hover:bg-yellow-600 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-bold py-4 px-8 rounded-lg transition-all transform hover:scale-105 text-xl"
              >
                {isProcessing ? 'Processing Payment...' : 'Mint Legacy Member NFT'}
              </button>

              <p className="text-sm text-gray-400 mt-4 text-center">
                Payment processed securely via ICP RPC canisters
              </p>
            </motion.div>
          ) : (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              className="glass-dark rounded-2xl p-8 text-center"
            >
              <div className="text-6xl mb-4">🎉</div>
              <h2 className="text-3xl font-bold text-gold mb-2">Welcome, Legacy Member!</h2>
              <p className="text-gray-300">Your exclusive NFT has been minted to your wallet.</p>
            </motion.div>
          )}
        </motion.div>
      </div>
    </BlacksmithWorkshop>
  );
}






